import(/* webpackMode: "eager" */ "/Users/prathamesh/Downloads/claude-transfer/locobuzz-website/app/platform/integrations/page.js");
